/**
 * Formatiert eine Zahl als Preis mit Tausender-Trennpunkten
 * @param {number|string} price - Der zu formatierende Preis
 * @param {string} currency - Die Währung (Standard: '€')
 * @param {string} locale - Das Locale für die Formatierung (Standard: 'de-DE')
 * @returns {string} - Der formatierte Preis
 */
export const formatPrice = (price, currency = '€', locale = 'de-DE') => {
  // Überprüfung auf gültige Eingabe
  if (price === null || price === undefined || price === '') {
    return '';
  }

  // Konvertiere zu Nummer falls String übergeben wurde
  const numericPrice = typeof price === 'string' ? parseFloat(price) : price;
  
  // Überprüfung auf gültige Zahl
  if (isNaN(numericPrice)) {
    return price.toString(); // Gib den ursprünglichen Wert zurück wenn nicht konvertierbar
  }

  // Formatiere mit Tausender-Trennpunkten
  const formattedNumber = numericPrice.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });

  return `${currency}${formattedNumber}`;
};

/**
 * Formatiert eine Zahl ohne Währungssymbol mit Tausender-Trennpunkten
 * @param {number|string} number - Die zu formatierende Zahl
 * @param {string} locale - Das Locale für die Formatierung (Standard: 'de-DE')
 * @returns {string} - Die formatierte Zahl
 */
export const formatNumber = (number, locale = 'de-DE') => {
  // Überprüfung auf gültige Eingabe
  if (number === null || number === undefined || number === '') {
    return '';
  }

  // Konvertiere zu Nummer falls String übergeben wurde
  const numericValue = typeof number === 'string' ? parseFloat(number) : number;
  
  // Überprüfung auf gültige Zahl
  if (isNaN(numericValue)) {
    return number.toString(); // Gib den ursprünglichen Wert zurück wenn nicht konvertierbar
  }

  // Formatiere mit Tausender-Trennpunkten
  return numericValue.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
};

/**
 * Formatiert einen Preis mit Euro-Symbol am Ende (für deutsche Darstellung)
 * @param {number|string} price - Der zu formatierende Preis
 * @param {string} locale - Das Locale für die Formatierung (Standard: 'de-DE')
 * @returns {string} - Der formatierte Preis mit € am Ende
 */
export const formatPriceEuroEnd = (price, locale = 'de-DE') => {
  // Überprüfung auf gültige Eingabe
  if (price === null || price === undefined || price === '') {
    return '';
  }

  // Konvertiere zu Nummer falls String übergeben wurde
  const numericPrice = typeof price === 'string' ? parseFloat(price) : price;
  
  // Überprüfung auf gültige Zahl
  if (isNaN(numericPrice)) {
    return price.toString(); // Gib den ursprünglichen Wert zurück wenn nicht konvertierbar
  }

  // Formatiere mit Tausender-Trennpunkten
  const formattedNumber = numericPrice.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });

  return `${formattedNumber} €`;
};